import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Search, Typography } from '@telus-uds/components-web';
import SearchWrapper from './css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import request from '../../../../utils/request';

const SearchBar = ({ setOrders, fetchOrders }) => {
  const localigedStrings = useLocalizedStringsContext();
  const {
    BUSINESS_APP_ORDERS: { searchHint, searchLabel }
  } = localigedStrings;
  const [searchString, setSearchString] = useState();

  const filterOrders = async (clearSearch = false) => {
    if (clearSearch) {
      fetchOrders();
      return;
    }

    if (searchString) {
      const response = await request.get(`/orders?type=BA&q=${searchString}`);
      if (response) setOrders(response);
    }
  };

  return (
    <SearchWrapper>
      <div style={{ maxWidth: '400px', width: '100%' }}>
        <Typography variant={{ size: 'small', weight: 'bold' }} style={{ marginBottom: '8px' }}>
          {searchLabel}
        </Typography>
        <Search
          label={searchLabel}
          placeholder={searchHint}
          value={searchString || ''}
          onChange={setSearchString}
          onSubmit={() => filterOrders()}
          onClear={() => {
            setSearchString('');
            filterOrders(true);
          }}
        />
      </div>
    </SearchWrapper>
  );
};

SearchBar.propTypes = {
  setOrders: PropTypes.func.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default SearchBar;
